module.exports = __webpack_public_path__ + "img/photo5.935e4583.png";